document.addEventListener("DOMContentLoaded", function () {
  if (document.querySelectorAll(".nativeSharing").length > 0) {
    const shareBtn = document.getElementById("shareBtn");
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const shareModal = document.getElementById("shareModal");
    const shareOptions = shareModal.querySelectorAll(
      ".share-modal-options [data-share]"
    );

    // Fetch meta tags and canonical URL
    const pageUrl =
      document.querySelector('meta[property="og:url"]')?.content ||
      document.querySelector('link[rel="canonical"]')?.href ||
      window.location.href;
    const pageTitle =
      document.querySelector('meta[property="og:title"]')?.content ||
      document.title;
    const pageDescription =
      document.querySelector('meta[property="og:description"]')?.content || "";
    const pageImage =
      document.querySelector('meta[property="og:image"]')?.content || "";

    function isAndroid() {
      return /android/i.test(userAgent);
    }

    function isIOS() {
      return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    }

    // Show modal on share button click if sharing is not supported
    shareBtn.addEventListener("click", function (event) {
      event.preventDefault();

      if (isAndroid()) {
        const intentUrl = `intent://share/#Intent;action=android.intent.action.SEND;type=text/plain;S.android.intent.extra.TEXT=${encodeURIComponent(
          pageUrl
        )};end`;
        window.location.href = intentUrl;
      } else if (isIOS() && navigator.share) {
        navigator
          .share({
            title: pageTitle,
            text: pageDescription,
            url: pageUrl,
          })
          .catch((error) => console.error("Error sharing:", error));
      }
    });

    // Handle share options
    shareOptions.forEach((option) => {
      option.addEventListener("click", function () {
        const shareType = this.getAttribute("data-share");
        const encodedUrl = encodeURIComponent(pageUrl);
        const encodedTitle = encodeURIComponent(pageTitle);
        const encodedDescription = encodeURIComponent(pageDescription);

        switch (shareType) {
          case "copy":
            navigator.clipboard
              .writeText(pageUrl)
              .then(() => {
                // alert('Link copied to clipboard!');
              })
              .catch((err) => {
                console.error("Failed to copy: ", err);
              });
            break;
          case "email":
            window.location.href = `mailto:?subject=${encodedTitle}&body=${encodedDescription}%0A${encodedUrl}`;
            break;
          case "whatsapp":
            window.open(
              `https://api.whatsapp.com/send?text=${encodedTitle}%0A${encodedUrl}`,
              "_blank"
            );
            break;
          case "messenger":
            window.open(
              `https://www.facebook.com/messenger/share/?link=${encodedUrl}&app_id=YOUR_APP_ID`,
              "_blank"
            );
            break;
          case "facebook":
            window.open(
              `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
              "_blank"
            );
            break;
          case "twitter":
            window.open(
              `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`,
              "_blank"
            );
            break;
          default:
            console.log("Share type not supported:", shareType);
        }
      });
    });
  }
});
